/* NAÏA — Sélecteurs fiche produit (format + achat/abonnement)
 *
 * - Le sélecteur de format pilote l'input `quantity` du formulaire produit.
 * - Le sélecteur d'achat écrit un input `selling_plan` rattaché au même formulaire.
 * - Les deux blocs se synchronisent via deux événements custom sur `document` :
 *     naia:quantity-change       { quantity }
 *     naia:purchase-mode-change  { mode, unitPrice }
 *   Chaque bloc peut être rendu seul : l'absence de l'autre n'est jamais bloquante.
 * - Sans JS : les deux blocs restent masqués (.naia-block { display:none }) et le
 *   formulaire d'achat natif reste pleinement fonctionnel.
 *
 * PRIX — aucune valeur en dur. Tout vient des data-* posés par le Liquid :
 *   data-naia-unit-price     prix unitaire (centimes)
 *   data-naia-tiers          paliers « Pack Naïa » : "2:5|3:10" (qté:%, séparés par |)
 *   data-naia-discount-pct   (compat.) remise à un seul palier (%)
 *   data-naia-discount-min   (compat.) quantité minimale de ce palier
 *   data-naia-money-format   {{ shop.money_format }}
 *   data-naia-plan-unit      per_delivery_price du selling_plan (centimes)
 *   data-naia-plan-compare   compare_at_price du selling_plan (centimes)
 *
 * ARRONDI — voir discountedLine() : Shopify remise À L'UNITÉ puis multiplie.
 *
 * RATTACHEMENT AU FORMULAIRE — voir attachToForm(). Trois pièges corrigés :
 *   1. `form.id` NE renvoie PAS l'id du formulaire (HTMLFormElement est
 *      [LegacyOverrideBuiltIns] : son named getter renvoie <input name="id">).
 *   2. le formulaire produit doit être cherché DANS la section du bloc, sinon on
 *      tombe sur le premier `<product-form>` de la page (quick-add d'un autre produit).
 *   3. buy-buttons.liquid rend DEUX <form 'product'> ; celui du bouton
 *      « Acheter maintenant » doit recevoir un miroir quantity/selling_plan.
 */
(function () {
  if (window.__naiaProductSelectors) return;
  window.__naiaProductSelectors = true;

  /* État partagé entre les deux blocs. */
  var state = {
    quantity: 1,
    mode: 'onetime',
    subUnitPrice: null
  };

  /* ----------------------------------------------------------------- utils */

  function emit(name, detail) {
    var evt;
    try {
      evt = new CustomEvent(name, { detail: detail, bubbles: true });
    } catch (e) {
      evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(name, true, false, detail);
    }
    document.dispatchEvent(evt);
  }

  function toInt(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  /* Paliers de remise « Pack Naïa » : "2:5|3:10" → [{q:2,pct:5},{q:3,pct:10}].
   * Repli sur (discount_pct, discount_min) si `data-naia-tiers` est absent. */
  function parseTiers(str, pct, minQty) {
    var tiers = [];
    if (str) {
      var parts = String(str).split('|');
      for (var i = 0; i < parts.length; i++) {
        var kv = parts[i].split(':');
        var q = toInt(kv[0], 0);
        var p = toInt(kv[1], 0);
        if (q > 0 && p > 0) tiers.push({ q: q, pct: p });
      }
    }
    if (!tiers.length && pct > 0) tiers.push({ q: minQty, pct: pct });
    tiers.sort(function (a, b) { return a.q - b.q; });
    return tiers;
  }

  /* Pourcentage applicable à une quantité = palier le plus élevé atteint. */
  function pctFor(tiers, qty) {
    var p = 0;
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].q) p = tiers[i].pct;
    }
    return p;
  }

  /* Lecture des paliers sur un bloc, avec repli sur l'autre bloc de la page
   * (le sélecteur d'achat n'a pas besoin de redéclarer les paliers). */
  function tiersOf(root) {
    var attr = root.getAttribute('data-naia-tiers');
    if (!attr) {
      var other = document.querySelector('[data-naia-tiers]');
      if (other) attr = other.getAttribute('data-naia-tiers');
    }
    var pct = toInt(root.getAttribute('data-naia-discount-pct'), 0);
    var minQty = toInt(root.getAttribute('data-naia-discount-min'), 2);
    return parseTiers(attr, pct, minQty);
  }

  /* Remise en centimes, arrondie au supérieur (conservateur). */
  function discounted(cents, pct) {
    if (!pct || pct <= 0) return cents;
    return Math.ceil((cents * (100 - pct)) / 100);
  }

  /* Prix d'une ligne remisée.
   * Shopify applique la remise automatique À L'UNITÉ puis multiplie par la
   * quantité. Remiser le total de ligne donne 1 centime d'écart avec le montant
   * réellement facturé (2 × 32,90 € : 62,51 € affiché vs 62,52 € facturés). */
  function discountedLine(unitCents, pct, qty) {
    return discounted(unitCents, pct) * qty;
  }

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents === null) return '0';
    var number = (cents / 100.0).toFixed(precision);
    var parts = number.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var frac = parts[1] ? decimal + parts[1] : '';
    return whole + frac;
  }

  /* Reproduit le filtre `money` de Liquid à partir de shop.money_format. */
  function formatMoney(cents, format) {
    var f = format || '{{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var match = f.match(re);
    var name = match ? match[1] : 'amount';
    var value;

    switch (name) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
    }
    return f.replace(re, value);
  }

  function show(el, visible) {
    if (!el) return;
    if (visible) el.removeAttribute('hidden');
    else el.setAttribute('hidden', 'hidden');
  }

  /* Section qui contient le bloc : sert de portée pour retrouver LE bon
   * formulaire produit (la page contient aussi des quick-add d'autres produits). */
  function sectionOf(root) {
    return (root && root.closest && root.closest('section')) || document;
  }

  /* Formulaire d'ajout au panier de la section du bloc.
   * On ne prend jamais `document.querySelector(...)` en premier : le premier
   * <product-form> de la page est un quick-add d'un AUTRE produit. */
  function findForm(root) {
    var scope = sectionOf(root);
    return (
      scope.querySelector('product-form form[data-type="add-to-cart-form"]') ||
      scope.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('product-form form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]')
    );
  }

  /* Rattache un input au formulaire produit.
   *
   * ⚠️ NE JAMAIS écrire `form.id` : HTMLFormElement porte [LegacyOverrideBuiltIns],
   * son named getter renvoie le contrôle nommé `id` — c'est-à-dire le
   * <input name="id" class="product-variant-id"> — AVANT la propriété `id` de
   * Element. `form.id` renvoie donc un HTMLInputElement, pas une chaîne.
   * `setAttribute('form', form.id)` écrivait littéralement
   * "[object HTMLInputElement]" : l'input n'avait AUCUN form owner et n'entrait
   * donc pas dans le `new FormData(this.form)` de product-form.js.
   *
   * On déplace donc l'input DANS le <form> : plus aucune dépendance ni à `id`
   * (que buy-buttons.liquid duplique entre ses deux <form>), ni à la
   * sérialisation du thème. */
  function attachToForm(input, form) {
    if (!input || !form) return false;
    input.removeAttribute('form');
    form.appendChild(input);
    return true;
  }

  /* Le bouton de paiement dynamique (« Acheter maintenant ») vit dans un SECOND
   * <form 'product'> rendu par buy-buttons.liquid, qui ne contient QUE l'id de
   * variante. Sans miroir, il part au checkout avec 1 unité en achat unique et
   * ignore les deux sélecteurs. On y maintient donc des inputs quantity et
   * selling_plan synchronisés avec le formulaire d'ajout au panier. */
  function findBuyNowForm(root) {
    var scope = sectionOf(root);
    var forms = scope.querySelectorAll('form[data-type="add-to-cart-form"]');
    var atc = findForm(root);
    for (var i = 0; i < forms.length; i++) {
      if (forms[i] !== atc) return forms[i];
    }
    return null;
  }

  function mirrorInput(form, name) {
    if (!form) return null;
    var el = form.querySelector('input[data-naia-mirror="' + name + '"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      el.setAttribute('data-naia-mirror', name);
      form.appendChild(el);
    }
    return el;
  }

  /* ------------------------------------------------- bloc 1 : format (qty) */

  function initFormat(root, form, buyNowForm) {
    var radios = root.querySelectorAll('input[data-naia-qty]');
    if (!radios.length) return;

    var qtyMirror = mirrorInput(buyNowForm, 'quantity');

    var money = root.getAttribute('data-naia-money-format');
    var unitPrice = toInt(root.getAttribute('data-naia-unit-price'), 0);
    var tiers = tiersOf(root);

    var scope = sectionOf(root);
    var qtyInput = scope.querySelector('input.quantity__input[name="quantity"]');
    var qtyWrapper = scope.querySelector('[id^="Quantity-Form-"]');

    // Si le bloc « Sélecteur de quantité » a été retiré du thème, on fabrique
    // un input quantity et on le place DANS le formulaire produit.
    if (!qtyInput && form) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      qtyInput.value = '1';
      attachToForm(qtyInput, form);
    }

    if (!qtyInput) return;

    // Le stepper natif ferait doublon : on le masque, le sélecteur le remplace.
    if (qtyWrapper) qtyWrapper.classList.add('naia-hidden');

    var options = root.querySelectorAll('[data-naia-option]');
    var notes = root.querySelectorAll('[data-naia-note]');

    function renderPrices() {
      var isSub = state.mode === 'subscription';
      var subUnit = state.subUnitPrice;

      for (var i = 0; i < options.length; i++) {
        var opt = options[i];
        var q = toInt(opt.getAttribute('data-naia-option'), 1);
        var nowEl = opt.querySelector('[data-naia-price-now]');
        var wasEl = opt.querySelector('[data-naia-price-was]');
        var saveEl = opt.querySelector('[data-naia-price-save]');

        var full = unitPrice * q;
        var finalPrice;
        var hasDisc;

        if (isSub) {
          // Un abonné n'a JAMAIS la remise pack (appliesOnSubscription: false).
          // On affiche le prix abonné réel (déjà remisé par Shopify), sans badge
          // ni prix barré : le sélecteur de format ne promet plus rien de faux.
          finalPrice = (subUnit === null ? unitPrice : subUnit) * q;
          hasDisc = false;
        } else {
          var qPct = pctFor(tiers, q);
          hasDisc = qPct > 0;
          finalPrice = hasDisc ? discountedLine(unitPrice, qPct, q) : full;
          if (saveEl && hasDisc) saveEl.textContent = '−' + qPct + ' %';
        }

        if (nowEl) nowEl.textContent = formatMoney(finalPrice, money);
        if (wasEl) {
          wasEl.textContent = formatMoney(full, money);
          show(wasEl, hasDisc);
        }
        show(saveEl, hasDisc);
      }

      for (var j = 0; j < notes.length; j++) {
        var note = notes[j];
        var kind = note.getAttribute('data-naia-note');
        show(note, isSub ? kind === 'subscription' : kind === 'onetime');
      }
    }

    function applyQty(radio) {
      var qty = toInt(radio.getAttribute('data-naia-qty'), 1);
      state.quantity = qty;
      qtyInput.value = String(qty);
      if (qtyMirror) qtyMirror.value = String(qty);
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      emit('naia:quantity-change', { quantity: qty });
    }

    root.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.hasAttribute && target.hasAttribute('data-naia-qty') && target.checked) {
        applyQty(target);
        renderPrices();
      }
    });

    document.addEventListener('naia:purchase-mode-change', function (event) {
      var detail = event.detail || {};
      state.mode = detail.mode === 'subscription' ? 'subscription' : 'onetime';
      state.subUnitPrice = typeof detail.unitPrice === 'number' ? detail.unitPrice : null;
      renderPrices();
    });

    // Défaut : la 1re pastille. On force la sélection pour neutraliser toute
    // restauration d'état par le navigateur (retour arrière / bfcache).
    var checked = null;
    for (var k = 0; k < radios.length; k++) {
      if (radios[k].checked) {
        checked = radios[k];
        break;
      }
    }
    if (!checked) {
      radios[0].checked = true;
      checked = radios[0];
    }
    applyQty(checked);
    renderPrices();

    root.classList.add('is-ready');
  }

  /* ------------------------------------ bloc 2 : achat unique / abonnement */

  function initPurchase(root, form, buyNowForm) {
    var planInput = root.querySelector('[data-naia-selling-plan-input]');
    if (!planInput) return;

    var planMirror = mirrorInput(buyNowForm, 'selling_plan');

    // Rattachement au formulaire produit : l'input est DÉPLACÉ dans le <form>.
    attachToForm(planInput, form);

    var money = root.getAttribute('data-naia-money-format');
    var unitPrice = toInt(root.getAttribute('data-naia-unit-price'), 0);
    var tiers = tiersOf(root);

    var plansBox = root.querySelector('[data-naia-plans]');
    var planRadios = root.querySelectorAll('input[data-naia-plan]');

    var onetimeNow = root.querySelector('[data-naia-onetime-now]');
    var onetimeWas = root.querySelector('[data-naia-onetime-was]');
    var onetimeSave = root.querySelector('[data-naia-onetime-save]');

    function checkedPlan() {
      return root.querySelector('input[data-naia-plan]:checked');
    }

    function planUnitPrice(planRadio) {
      if (!planRadio) return null;
      var row = planRadio.parentNode;
      var priceEl = row ? row.querySelector('[data-naia-plan-price]') : null;
      if (!priceEl) return null;
      var v = parseInt(priceEl.getAttribute('data-naia-plan-unit'), 10);
      return isNaN(v) ? null : v;
    }

    function renderPrices() {
      var qty = state.quantity;

      // Carte « Achat unique » : prix unitaire remisé × quantité selon le palier atteint.
      var full = unitPrice * qty;
      var qPct = pctFor(tiers, qty);
      var hasDisc = qPct > 0;
      var finalPrice = hasDisc ? discountedLine(unitPrice, qPct, qty) : full;
      if (onetimeSave && hasDisc) onetimeSave.textContent = '−' + qPct + ' %';

      if (onetimeNow) onetimeNow.textContent = formatMoney(finalPrice, money);
      if (onetimeWas) {
        onetimeWas.textContent = formatMoney(full, money);
        show(onetimeWas, hasDisc);
      }
      show(onetimeSave, hasDisc);

      // Lignes de fréquence : le prix abonné est DÉJÀ remisé par Shopify.
      // On multiplie par la quantité, sans jamais appliquer la remise pack.
      var rows = root.querySelectorAll('[data-naia-plan-price]');
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var unit = parseInt(row.getAttribute('data-naia-plan-unit'), 10);
        var compare = parseInt(row.getAttribute('data-naia-plan-compare'), 10);
        var nowEl = row.querySelector('[data-naia-plan-now]');
        var wasEl = row.querySelector('[data-naia-plan-was]');

        if (nowEl && !isNaN(unit)) nowEl.textContent = formatMoney(unit * qty, money);
        if (wasEl) {
          var showWas = !isNaN(compare) && !isNaN(unit) && compare > unit;
          if (showWas) wasEl.textContent = formatMoney(compare * qty, money);
          show(wasEl, showWas);
        }
      }
    }

    function sync() {
      var mode = root.querySelector('input[data-naia-mode]:checked');
      var isSub = !!mode && mode.getAttribute('data-naia-mode') === 'subscription';
      var subCard = root.querySelector('input[data-naia-mode="subscription"]');

      // Bascule vers l'abonnement sans fréquence cochée : on prend la première.
      if (isSub && planRadios.length && !checkedPlan()) planRadios[0].checked = true;

      if (plansBox) plansBox.hidden = !isSub;
      if (subCard) subCard.setAttribute('aria-expanded', isSub ? 'true' : 'false');

      var plan = checkedPlan();
      if (isSub && plan) {
        planInput.value = plan.value;
        planInput.disabled = false;
      } else {
        planInput.value = '';
        planInput.disabled = true;
      }

      // Miroir vers le formulaire du bouton « Acheter maintenant ».
      if (planMirror) {
        planMirror.value = planInput.value;
        planMirror.disabled = planInput.disabled;
      }

      state.mode = isSub ? 'subscription' : 'onetime';
      state.subUnitPrice = isSub ? planUnitPrice(plan) : null;

      renderPrices();
      emit('naia:purchase-mode-change', { mode: state.mode, unitPrice: state.subUnitPrice });
    }

    root.addEventListener('change', sync);

    document.addEventListener('naia:quantity-change', function (event) {
      var detail = event.detail || {};
      if (typeof detail.quantity === 'number') state.quantity = detail.quantity;
      renderPrices();
    });

    // Défauts imposés (recommandation UX Shopify) : « Achat unique » coché,
    // 1re fréquence pré-sélectionnée. Forcé en JS pour neutraliser toute
    // restauration d'état par le navigateur.
    var onetimeRadio = root.querySelector('input[data-naia-mode="onetime"]');
    if (onetimeRadio) onetimeRadio.checked = true;
    for (var i = 0; i < planRadios.length; i++) {
      planRadios[i].checked = i === 0;
    }

    sync();
    root.classList.add('is-ready');
  }

  /* ------------------------------------------------------------------ init */

  function init() {
    var format = document.querySelector('[data-naia-format]');
    var purchase = document.querySelector('[data-naia-purchase]');
    if (!format && !purchase) return;

    // Le formulaire est cherché dans la section du bloc, pas dans tout le document.
    var anchor = purchase || format;
    var form = findForm(anchor);

    // Produit non achetable (tag « bientot-disponible » : buy-buttons.liquid ne
    // rend aucun formulaire) → on n'affiche ni format ni abonnement, plutôt
    // qu'un sélecteur d'achat orphelin sans bouton.
    if (!form) return;

    var buyNowForm = findBuyNowForm(anchor);
    if (format) initFormat(format, form, buyNowForm);
    if (purchase) initPurchase(purchase, form, buyNowForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
